<div class="c-multichallenges">
  <div
    class="c-multichallenges__background"
    theming
    themingGroup="gamechallenges"
    themingAsset="background"
    [themingOverride]="gameChallenge()?.assets">
    <slotcom-wallet
      [type]="'Coins'"
      [animate]="true"></slotcom-wallet>

    <slotcom-navigation-button
      type="close"
      (click)="closeModal()">
    </slotcom-navigation-button>

    <div class="c-container">
      <div class="c-multichallenges__title">
        <span
          class="c-multichallenges__icon"
          theming
          themingGroup="gamechallenges"
          themingAsset="logo"
          [themingOverride]="gameChallenge()?.assets"></span>

        <div class="c-multichallenges__subtitle">
          <span class="text title">{{ 'home.live-ops.multichallenges.title' | translate | uppercase }}</span>
          <span class="text subtitle">{{ 'home.live-ops.multichallenges.subtitle' | translate }}</span>
        </div>
      </div>

      <div
        invertMouseScroll
        id="multichallenges-scroll-container"
        class="c-multichallenges__container">
        <div class="c-multichallenges__events">
          @for (
            challengeStatus of gameChallenge()?.properties?.challengestatuses;
            track challengeStatus;
            let i = $index
          ) {
            <div
              class="c-multichallenges__events_card"
              theming
              themingGroup="gamechallenges"
              themingAsset="box"
              [themingOverride]="gameChallenge()?.assets">
              <div class="c-multichallenges__events_card_absolute">
                <div class="c-multichallenges__events_top">
                  @if (challengeStatus.isGeneric) {
                    <div
                      class="c-multichallenges__events_image no-pointer"
                      theming
                      themingGroup="tournament"
                      themingAsset="generic-icon"
                      [themingOverride]="gameChallenge()?.assets"></div>
                  } @else {
                    <div
                      avoidMulticlick
                      class="c-multichallenges__events_image"
                      [ngStyle]="gameIcon[i]"
                      (safeClick)="goToGame(challengeStatus.gameId)"></div>
                  }
                  <div class="c-multichallenges__events_text">
                    <span class="text challengeText"> {{ challengeText[i] | uppercase }} </span>
                    @if (challengeStatus.minBet !== 0) {
                      <span class="text minBet"
                        >{{ 'home.live-ops.gamechallenges.min-stake-of' | translate }}
                        {{ challengeStatus.minBet | number: '1.0-0' : ('common.culture' | translate) }}</span
                      >
                    }
                  </div>
                  <div
                    class="c-multichallenges__events_progress"
                    [ngClass]="gameChallenge()?.properties.challengestatuses[0]?.minBet !== 0 ? 'margin-top' : ''">
                    <slotcom-progress-bar
                      [classes]="['c-progress-bar--green-black']"
                      [currentProgress]="challengeStatus.current"
                      [totalProgress]="challengeStatus.total"
                      [completed]="challengeStatus.finished ? challengeStatus.finished : true">
                      <span class="text percent">
                        {{
                          challengeStatus.current < challengeStatus.total
                            ? (challengeStatus.current | notRoundingBeautifyNumber: ('common.culture' | translate)) +
                              ' / ' +
                              (challengeStatus.total | notRoundingBeautifyNumber: ('common.culture' | translate))
                            : ('home.live-ops.multichallenges.completed' | translate | uppercase)
                        }}
                      </span>
                    </slotcom-progress-bar>
                  </div>
                </div>
                <div class="c-multichallenges__events_bot">
                  <div
                    class="c-multichallenges__events_reward"
                    [ngClass]="challengeStatus.redeemed ? 'less-brightness' : ''">
                    <span class="text reward-text">{{
                      'home.live-ops.gamechallenges.reward' | translate | uppercase
                    }}</span>
                    <slotcom-display [classes]="['c-display--gameChallenges']">
                      <div
                        displayIcon
                        displayIconPos="left"
                        class="c-display--coin"></div>
                      <span class="text reward">{{
                        challengeStatus.reward.credits | beautifyNumber: ('common.culture' | translate)
                      }}</span>
                    </slotcom-display>
                    @if (challengeStatus.finished && challengeStatus.redeemed) {
                      <div class="e-checkIcon"></div>
                    }
                  </div>
                  @if (!challengeStatus.redeemed) {
                    <slotcom-button
                      class="c-button--pink"
                      (safeClick)="manageEvent(challengeStatus)"
                      [isLoading]="redeemingIds().has(challengeStatus.id)"
                      audioType="functionality">
                      @if (!challengeStatus.finished) {
                        {{
                          (gameChallenge()?.statusCultureButtonText[lang]
                            ? gameChallenge()?.statusCultureButtonText[lang]
                            : ('common.play' | translate)
                          ) | uppercase
                        }}
                      } @else {
                        {{ 'common.collect' | translate | uppercase }}
                      }
                      <ng-template #completed>
                        {{ 'common.collect' | translate | uppercase }}
                      </ng-template>
                    </slotcom-button>
                  }
                  @if (challengeStatus.redeemed) {
                    <slotcom-box [classes]="['gameChallengesCompleted']">
                      <span class="text completed">{{
                        'home.live-ops.gamechallenges.completed' | translate | uppercase
                      }}</span>
                    </slotcom-box>
                  }
                </div>
              </div>
            </div>
          }

          <div class="c-multichallenges__events_timer">
            @if (showTimer()) {
              <div>
                <span class="text">{{ 'home.live-ops.global.time-left' | translate }}</span>
                <slotcom-animated-timer
                  [showInDays]="true"
                  [endDate]="gameChallenge()?.endDate"
                  (expired)="onExpiredChallenge()"></slotcom-animated-timer>
              </div>
            }
          </div>
        </div>

        @if (showArrows()) {
          <span
            moveWithArrows
            direction="left"
            scrollContainer="multichallenges-scroll-container"
            class="arrows left-arrow"></span>
          <span
            moveWithArrows
            direction="right"
            scrollContainer="multichallenges-scroll-container"
            class="arrows right-arrow"></span>
        }
      </div>
    </div>
  </div>
</div>
